import { createSelector } from 'reselect'

export const selectCurrentLanguageCode = createSelector(
    state => state.languages.currentLanguageCode,
    code => code
)
